








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Loading extends Vue {
  @Prop({ default: 80 }) private sizePx! :number;
  
  public get size() : string {
    return this.sizePx + "px";
  }
}
